// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fY","advertDetailHeaderPrice__value":"c-m_fZ","advertDetailHeaderPrice__label":"c-m_ga"};